<template>
  <div class="px-5" id="page-shortlink">
    <m-row v-if="ok === true">
      <m-col lg="12">
        <div class="text-center">
          <span>Du har avregistrerat dig från framtida SMS utskick!</span>
        </div>
      </m-col>
    </m-row>
    <m-row>
      <m-col lg="12">
        <span>Ett fel uppstod</span>
      </m-col>
    </m-row>
  </div>
</template>
  
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';

export default {
  name: 'UnregisterSMS',
  components: {

  },
  computed: {
    
  },
  async mounted() {
    this.token = this.$route.params.token;
    this.member_id = this.$route.params.member_id;

    setTimeout(()=>{
      this.unreg_sms(this.member_id, this.token);
    }, 1000);
  },
  data() {
    return {
      member_id: null,
      token: null,
      ok: null
    };
  },
  watch: {

  },
  methods: {

    async unreg_sms(member_id, token) {
      try {
        const res = await axios.post(`/member/unreg/sms/${member_id}`, { token: this.token });
        if (res.status === 200) {
          this.ok = true;
          return;
        }
      }
      catch (err) {
        console.error('unreg_sms error', err);
      }
      this.ok = false;
    }
  }
};
</script>
  